import { CIP_ELIGIBILITY_CODES } from 'shared/shared_consts'

export const getMaxLimitReachedSelector = state => {
  const statusCode =
    state.current_user.CIPEligibility.CROWD_FUNDING?.CIPStatusCode
  return (
    statusCode === CIP_ELIGIBILITY_CODES.USER_REACHED_CAMPAIGN_CREATION_LIMIT
  )
}
